import State, { active } from '../State';

export interface SetActive {
	tag : 'SetActive';
	val : string;
}

export const setActive = ( val : string ) : SetActive =>
	( { tag : 'SetActive' , val } );

export const exeSetActive = ( state : State , cmd : SetActive ) : State =>
	active( _ => cmd.val )( state );
